<template>
    <div class="subPage">
        <div class="main">
            <!-- 头像 -->
            <Avatar
                :imageSrc="userInfo.headUrl"
                :editAvatar="menuTypes.editAvatar"
            />
            <!-- 编辑区域 -->
            <div class="userInfo">
                <input
                    maxlength="10"
                    class="input"
                    type="text"
                    :value="userInfo.nick"
                    :placeholder="'输入/修改名字'"
                    v-on:input="editUserName"
                />
              <input
                    maxlength="50"
                    class="input"
                    type="textarea"
                    :value="userInfo.sign"
                    :placeholder="'输入/修改个性签名'"
                    v-on:input="editSign"
                />
            </div>
            <!-- 上传微信二维码 -->
            <UploadWxCode
                :menuTypes="menuTypes"
                :uploadWxCode="uploadWxCode"
                :wxQrcodeCardUrl="userInfo.wxQrcodeCardUrl"
            />
            <br />
            <!-- 保存按钮 -->
            <div class="saveContainer">
                <mt-button class="save" @click="saveUserInfo">{{ menuTypes.save }}</mt-button>
            </div>
            <!--<input type="file" class="hidden" >-->
            <!-- 占位 -->
            <Empty />
        </div>
      <go-back-home/>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Input from '../comm/Input';
import Empty from '../comm/Empty';
import Avatar from '../userEditElement/Avatar';
import UploadWxCode from '../userEditElement/UploadWxCode';


export default {
  name: 'UserDetail',
  meta:{page:true},
  computed: {
        ...mapGetters('userinterface', {
            menuTypes: 'getMenuType',
        }),
        ...mapGetters('user', {
            userInfo: 'getUserInfo',
        })
  },
//beforeDestroy() {
//    this.$store.dispatch('user/getUserInfo');
//},
  created() {
       this.$store.dispatch('user/getUserInfo');
  },
  methods: {
    ...mapActions('user', [
      'editUserName',
      'editSign',
      'uploadWxCode',
      'editUserInfo'
    ]),
    saveUserInfo () {
      if(!this.userInfo.nick) {
        this.$toast({
          message: '昵称不允许为空',
          position: 'middle',
          duration: 1000
        });
        return false;
      } else {
        this.editUserInfo(this.userInfo)
      }
    }
  },
  components: {
    Input,
    Avatar,
    Empty,
    UploadWxCode
  },
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.main {
    .input {
        width: 220px;
        height: 40px;
        background-color: #fff;
        margin-bottom: 8px;
        border-radius: 4px;
        outline-style: none ;
        outline-width: 0px ;
        color: #000;
        text-indent: 12px;
        border: 1px solid #009688;
        -webkit-appearance: none;
    }
    $mainWidthSize: 220px;
    border-radius: 4px;
    background-color: #fff;
    margin: 15px;
    // margin-top: 51px;
    margin-bottom: 30px;
    .userInfo {
      /*text-align: center;*/
         display: flex;
	    flex-direction: column;
	    justify-content: center;
	    align-items: center;
    }
    .saveContainer {
        width: 90%;
        padding: 0 5%;
    }
    .save {
        width: 100%;
        background: #009688;
        color: #fff;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/UserEdit.vue